import { Component } from '@angular/core';

@Component({
    selector: 'app-participation',
    templateUrl: './participation.component.html',
    styleUrls: ['./participation.component.scss']
})
export class ParticipationComponent {
}
